import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './footer-disclaimer.scss.js';

class FooterDisclaimer extends s {
    constructor() {
        super(...arguments);
        this.text = '';
    }
    render() {
        return $ `<div class="footer-disclaimer"><p class="footer-disclaimer__text">${this.text}</p></div>`;
    }
}
FooterDisclaimer.styles = css_248z;
__decorate([
    e({ type: String })
], FooterDisclaimer.prototype, "text", void 0);
customElements.define('footer-disclaimer', FooterDisclaimer);

export { FooterDisclaimer };
